import { format, formatDistance, isFuture, isValid, parseISO } from "date-fns";
function convertUtcStringToLocal(dateStr) {
    const parsedDate = new Date(dateStr);
    const localDate = new Date(Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate(), parsedDate.getHours(), parsedDate.getMinutes(), parsedDate.getSeconds(), parsedDate.getMilliseconds()));
    return localDate;
}
export const startOfToday = () => format(new Date(), "yyyy-MM-dd") + "T00:00:00.000";
export const distanceAgo = (isoString) => isoString &&
    formatDistance(convertUtcStringToLocal(isoString), new Date(), {
        addSuffix: true,
    });
export const utcToLocalDate = (isoString) => isoString && format(convertUtcStringToLocal(isoString), "dd/MM/yyyy");
export const utcToLocalDateTime = (isoString) => {
    return isoString && format(convertUtcStringToLocal(isoString), "dd/MM/yyyy HH:mm");
};
export const isFutureDate = (utcIsoString) => utcIsoString && (isFuture(new Date(utcIsoString)));
export const isIsoDateString = (arg) => !!arg && isValid(parseISO(arg));
